__turbopack_context__.v({
  "cautious": "status-indicator-module__Oi8r-q__cautious",
  "critical": "status-indicator-module__Oi8r-q__critical",
  "draft": "status-indicator-module__Oi8r-q__draft",
  "failed": "status-indicator-module__Oi8r-q__failed",
  "high": "status-indicator-module__Oi8r-q__high",
  "incomplete": "status-indicator-module__Oi8r-q__incomplete",
  "indicator": "status-indicator-module__Oi8r-q__indicator",
  "informative": "status-indicator-module__Oi8r-q__informative",
  "label": "status-indicator-module__Oi8r-q__label",
  "low": "status-indicator-module__Oi8r-q__low",
  "medium": "status-indicator-module__Oi8r-q__medium",
  "stable": "status-indicator-module__Oi8r-q__stable",
  "undefined": "status-indicator-module__Oi8r-q__undefined",
});
